import { message } from 'antd';
import axios from 'axios';
import { messageConfiguration } from '../../utils';
const ApiService = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_BASE_URL,
})
// Add a request interceptor
ApiService.interceptors.request.use((config) => {
  // Add the timestamp to the headers of the API request
  config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return config;
});

// Add a response interceptor
ApiService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, config } = error.response || {};

    const authApis = [
      "vendor/auth/login",
      "vendor/auth/forgot-password",
      "vendor/auth/verify-forgot-otp",
      "vendor/auth/reset-password",
    ];

    const isAuthApi = authApis.some((api) =>
      config?.url?.includes(api)
    );
    if (status === 401 && !isAuthApi) {
      localStorage.clear();
      message.open(
        messageConfiguration("error", "Session Timeout", 3)
      );
      window.location.href = "/vendor";
    }

    if (status >= 400 && status < 500) {
      message.open(
        messageConfiguration(
          "error",
          error.response.data.message,
          3
        )
      );
    }

    return Promise.reject(error);
  }
);

export default ApiService;